require('./dateparser');

var MODULE_NAME = 'ui.bootstrap.module.dateparser';

angular.module(MODULE_NAME, ['ui.bootstrap.dateparser']);

module.exports = MODULE_NAME;



//////////////////
// WEBPACK FOOTER
// ./~/angular-ui-bootstrap/src/dateparser/index.js
// module id = 630
// module chunks = 1